import { render, staticRenderFns } from "./LanguageSettingsModal.vue?vue&type=template&id=48577c1a"
import script from "./LanguageSettingsModal.vue?vue&type=script&lang=js"
export * from "./LanguageSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48577c1a')) {
      api.createRecord('48577c1a', component.options)
    } else {
      api.reload('48577c1a', component.options)
    }
    module.hot.accept("./LanguageSettingsModal.vue?vue&type=template&id=48577c1a", function () {
      api.rerender('48577c1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserMenu/LanguageSettingsModal.vue"
export default component.exports